exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.HandsFreeErrorModal{position:fixed;top:0;left:0;display:flex;justify-content:center;align-items:center;z-index:101;width:100vw;height:100vh;max-height:unset;background-color:#00000073}.HandsFreeErrorModal .handsfree-error-container{display:flex;flex-direction:column;justify-content:center;align-items:center;width:300px;height:400px;border-radius:8px;background-color:#fff}.HandsFreeErrorModal .handsfree-error-container img{width:100px}.HandsFreeErrorModal .handsfree-error-container h1{margin-top:0;font-family:Open Sans,sans-serif;font-size:20px;font-weight:600;letter-spacing:-.2px;text-align:center;color:#d0021b}.HandsFreeErrorModal .handsfree-error-container p{margin:0;width:190px;height:84px;font-family:Open Sans,sans-serif;font-size:17px;font-style:italic;line-height:1.75;letter-spacing:-.16px;color:#000}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/HandsFreeErrorModal/HandsFreeErrorModal.scss
// module id = 1707
// module chunks = 0